import { render, staticRenderFns } from "./Users_employees.vue?vue&type=template&id=6d438924"
import script from "./Users_employees.vue?vue&type=script&lang=js"
export * from "./Users_employees.vue?vue&type=script&lang=js"
import style0 from "./Users_employees.vue?vue&type=style&index=0&id=6d438924&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports